import { render, staticRenderFns } from "./storeStaff.vue?vue&type=template&id=a351778c&scoped=true&"
import script from "./storeStaff.vue?vue&type=script&lang=js&"
export * from "./storeStaff.vue?vue&type=script&lang=js&"
import style0 from "./storeStaff.vue?vue&type=style&index=0&id=a351778c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a351778c",
  null
  
)

export default component.exports